// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PersonSearch20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PersonSearch20: FC<PersonSearch20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9 10a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 6 7c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 9 4c.833 0 1.542.292 2.125.875S12 6.167 12 7s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 9 10Zm.004-1.5c.414 0 .767-.147 1.059-.442.291-.294.437-.649.437-1.062 0-.414-.147-.767-.442-1.059A1.456 1.456 0 0 0 8.996 5.5c-.414 0-.767.147-1.059.442A1.456 1.456 0 0 0 7.5 7.004c0 .414.147.767.442 1.059.294.291.649.437 1.062.437Zm9.434 11-2.563-2.563a5.031 5.031 0 0 1-.906.407A3.046 3.046 0 0 1 14 17.5c-.972 0-1.799-.34-2.48-1.02-.68-.681-1.02-1.508-1.02-2.48s.34-1.799 1.02-2.48c.681-.68 1.508-1.02 2.48-1.02s1.799.34 2.48 1.02c.68.681 1.02 1.508 1.02 2.48 0 .333-.052.656-.156.969-.104.312-.24.614-.407.906l2.563 2.563-1.063 1.062ZM13.995 16c.559 0 1.033-.193 1.422-.579A1.92 1.92 0 0 0 16 14.005c0-.559-.193-1.033-.579-1.422A1.92 1.92 0 0 0 14.005 12c-.559 0-1.033.193-1.422.579A1.92 1.92 0 0 0 12 13.995c0 .559.193 1.033.579 1.422a1.92 1.92 0 0 0 1.416.583ZM3 16v-2c0-.344.087-.662.26-.956.174-.293.414-.523.72-.69a10.324 10.324 0 0 1 2.905-1.135 9.452 9.452 0 0 1 3.094-.177 8.245 8.245 0 0 0-.43.699c-.134.244-.24.497-.32.759a8.002 8.002 0 0 0-2.333.26 8.476 8.476 0 0 0-2.167.907.38.38 0 0 0-.169.138.346.346 0 0 0-.06.195v.5h4.52c.029.264.074.52.136.77.063.25.15.494.26.73H3Z" />
        </svg>
    );
};

export default PersonSearch20;
